<template>
  <div class="content">
    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 单据详情
      </h3>
      <div class="tu-class">

        <el-form :model="formData" label-position="left" label-width="80px" size="default">
          <div class="table-container">
            <h2 align="center">发货申请单</h2>
            <table class="table-layout">
              <tbody>
                <tr>
                  <td class="table-cell" colspan="2">公司名称</td>
                  <td class="table-cell" colspan="2">
                    <span>{{formData.companyName}}</span>
                  </td>
                  <td class="table-cell" colspan="2">业务员</td>
                  <td class="table-cell" colspan="2">
                    <span>{{formData.salesMan}}</span>
                  </td>
                </tr>

                <tr>
                  <td class="table-cell" colspan="2">申请原因</td>
                  <td class="table-cell" colspan="2">
                    <span>{{formData.applyCause}}</span>
                  </td>
                  <td class="table-cell" colspan="2">使用设备及描述</td>
                  <td class="table-cell" colspan="2">
                    <span>{{formData.useDevice}}</span>
                  </td>
                </tr>
                <tr>
                  <td class="table-cell" colspan="8">申请内容</td>
                </tr>
                <tr>
                  <td class="table-cell" style="height: 70px !important">运营商</td>
                  <td class="table-cell">卡类型</td>
                  <td class="table-cell" colspan="2">套餐内容(注明配套餐出货或用户充值)/地区</td>
                  <td class="table-cell">数量(PCS)</td>
                  <!--<td class="table-cell">单位</td>-->
                  <td class="table-cell">单价(元)</td>
                  <td class="table-cell">总金额(元)</td>
                  <td class="table-cell">操作</td>
                </tr>
                <tr v-for="(content, index) in formData.contentList" :key="index">
                  <td class="table-cell" style="height: 70px !important">
                    <template>
                      <span v-if="content.operatorName=='0'">中国移动</span>
                      <span v-if="content.operatorName=='1'">中国联通</span>
                      <span v-if="content.operatorName=='2'">中国电信</span>
                      <span v-if="content.operatorName=='3'">国际</span>
                    </template>
                  </td>
                  <td class="table-cell">
                    <template>
                      <span>{{content.cardList.filter(t=> t!=null&&t!=undefined&&t!='').join(",")}}</span>
                    </template>
                  </td>
                  <td class="table-cell" colspan="2"><span>{{content.packageContent}}</span></td>
                  <td class="table-cell"><span>{{content.quantity}}</span></td>
                  <!--<td class="table-cell"><span>{{content.units}}</span></td>-->
                  <td class="table-cell"><span>{{content.unitPrice}}</span></td>
                  <td class="table-cell"><span>{{content.grossAmount}}</span></td>
                  <td class="table-cell"></td>
                </tr>

                <tr>
                  <td class="table-cell" colspan="2">运输方式</td>
                  <td class="table-cell" colspan="2">
                    <template>
                      <span v-if="formData.modeOfTransport==0">自提</span>
                      <span v-if="formData.modeOfTransport==1">送货</span>
                      <span v-if="formData.modeOfTransport==2">快递寄付</span>
                      <span v-if="formData.modeOfTransport==3" style="margin-left:-28px">快递到付</span>
                    </template>
                  </td>
                  <td class="table-cell">要求发货日期</td>
                  <td class="table-cell" colspan="3">
                    <span>{{formData.deliveryDate}}</span>
                  </td>
                </tr>
                <tr>
                  <td class="table-cell" colspan="2">收货地址</td>
                  <td class="table-cell" colspan="6">
                    <span>{{formData.shippingAddress}}</span>
                  </td>
                </tr>
                <tr>
                  <td class="table-cell" colspan="2">收货人</td>
                  <td class="table-cell" colspan="2">
                    <span>{{formData.consignee}}</span>
                  </td>
                  <td class="table-cell">收货人电话</td>
                  <td class="table-cell" colspan="3">
                    <span>{{formData.receivingPhone}}</span>
                  </td>
                </tr>
                <tr>
                  <td class="table-cell" colspan="2">是否付款
                  </td>
                  <td class="table-cell" colspan="2">
                      <template>
                          <p>
                              <el-radio v-model="formData.whetherToPay"  label="1">是</el-radio>
                              <el-radio v-model="formData.whetherToPay"  label="0">否</el-radio>
                          </p>
                          <p>
                              <el-input placeholder="预计付款时间:" readonly="readonly"  prefix-icon="el-icon-date" v-model="formData.toPayDate"></el-input>
                              <!--<el-date-picker v-model="formData.toPayDate" type="date" format="yyyy-MM-dd" placeholder="预计付款时间:"></el-date-picker>-->
                          </p>
                      </template>
                  </td>
                  <td class="table-cell">付款方式</td>
                  <td class="table-cell" colspan="3">
                    <template>
                      <span v-if="formData.payMode==0">对公转账</span>
                      <span v-if="formData.payMode==1">微信</span>
                      <span v-if="formData.payMode==2">支付宝</span>
                      <span v-if="formData.payMode==3">测试</span>
                    </template>
                  </td>
                </tr>
                <tr>
                  <td class="table-cell" colspan="2">支付凭证或申请说明（截图）</td>
                  <td class="table-cell" colspan="6" style="height: 100px !important">
                      <el-image v-if="formData.payVoucher" class="avatar" :src="formData.payVoucher" :preview-src-list="[formData.payVoucher]"></el-image>
                  </td>
                </tr>
                <tr>
                  <td class="table-cell" colspan="2">备注</td>
                  <td class="table-cell" colspan="6">
                    <span>{{formData.remark}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-form>

      </div>
    </div>

      <div class="lct-class">
          <h3 class="detail-h3">
              <i class="el-icon-monitor"></i> 流程历史跟踪
          </h3>
          <el-table :data="tableData" border>
              <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
              <el-table-column prop="activityName" label="名称" align="center"></el-table-column>
              <el-table-column prop="startTime" label="开始时间" align="center"></el-table-column>
              <el-table-column prop="endTime" label="结束时间" align="center"></el-table-column>
              <el-table-column prop="assignee" label="负责人" align="center"></el-table-column>
              <el-table-column prop="status" label="处理结果" align="center"></el-table-column>
              <el-table-column prop="reason" label="处理意见" align="center"></el-table-column>
          </el-table>
      </div>

  </div>
</template>
<script>
  import { findShipmentRequestById} from "@/api/api.js";//附加单据
  import { historicActivityInstance } from "@/api/api.js";//记录展示
  export default {
    //name: "shipmentDetail",
    data() {
      return{
        processId: this.$route.query.processId,
        id: this.$route.query.id,
        formData: {},
        formData2: {},
        tableData:[],
      }
    },
    methods: {
      initData(){
          if (this.processId) {
              historicActivityInstance({processInstanceId: this.processId}).then(res=>{
                  if (res.data.code == 200) {
                      this.tableData = res.data.data;
                      this.tableData.map((item,index)=>{
                          item.ids = index + 1;
                      })
                  }
              });
          };
        //发货申请
        let params1 = {id: this.id};
          findShipmentRequestById(params1).then(res=>{
          if (res.data.code == 200) {
            this.formData = res.data.data;
          }
        });
      },

    },
    created() {
      //this.id =  this.$route.query.id;
    },
    mounted() {
      this.initData()
    },
  };
</script>
<style scoped lang="less">
  .lct-class{
    padding-bottom: 50px;
    .detail-h3 {
      font-size: 20px;
      color: #000000;
      padding-bottom: 30px;
      box-sizing: border-box;
    }
    .detail-h3 i {
      color: #5298ff;
    }
  }

  .el-row {
    //   margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 0px;
    //   min-height: 36px;
    border: 1px solid #4d4d4d;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 46px;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;
  }

  .grid-content-image {
    border-radius: 4px;
    min-height: 300px;
    padding: 10px;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;
  }

  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

  div.table-container {
    margin-top: 50px;
    margin-left: 220px;
    max-width: 1200px;
    padding: 20px;
    border-radius: 5px;
    border: 1px solid black;
    table.table-layout {
      table-layout: fixed;
      border-collapse: collapse;
      width: 1080px;

      td.table-cell {
        display: table-cell;
        height: 36px;
        border: 1px solid black;
        text-align: center;
      }
      td.table-cell-left {
        display: table-cell;
        height: 36px;
        border: 1px solid black;
      }
    }
  }
  .table-checkbox,
  .table-radio {
    display: table-cell;
    border: 1px solid black;
    text-align: left;
  }

  .add-button {
    margin-top: -340px;
    margin-right: -10px;
    float: right;
    position: relative;
  }
  .save {
    margin-top: 50px;
    margin-left: 750px;
    position: relative;
  }
  .text-input {
    width: 100%;
    height: 100%;
    padding: 5px;
    border: 1px #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    text-align: center;
  }
  .text-input-left {
    width: 100%;
    height: 100%;
    padding: 5px;
    border: 1px #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    text-align: left;
  }
  .radio-input {
    vertical-align: middle;
    margin-top: -2px;
    margin-bottom: 1px;
  }
  .avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 138px;
    height: 138px;
  }
  .avatar-uploader:hover {
    border-color: #409eff;
  }
  .svg-avatar-uploader-icon {
    font-size: 28px;
    width: 60px;
    height: 60px;
    line-height: 18px;
    text-align: center;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 138px;
    height: 138px;
    line-height: 138px;
    text-align: center;
  }
  .avatar {
    width: 138px;
    height: 138px;
    display: block;
  }

  .lct-class{
    padding-bottom: 50px;
    .detail-h3 {
      font-size: 20px;
      color: #000000;
      padding-bottom: 30px;
      box-sizing: border-box;
    }
    .detail-h3 i {
      color: #5298ff;
    }
    .nr-class{
      margin-top: 20px;
      margin-left: 10px;
    }
    .yjp-class{
      margin-top: 20px;
    }
  }
</style>


